/** The `modules` area: the platform modules an item can add as sections
 *  (src/domain/modules.ts), their names, descriptions, field labels and help.
 *  `MODULES` takes its English from here, so the catalog is the one source. */
export const modules = {
  'modules.resources.label': 'Resources',
  'modules.resources.description': 'Planned capacity: effort, a rough estimate, and budget.',
  'modules.resources.allocation.label': 'Allocation',
  'modules.resources.allocation.help':
    "The contributor's planned effort on this item, in the chosen unit. FTE is a share of one full-time person; over 1.0 FTE reads as over-committed.",
  'modules.resources.allocationUnit.label': 'Allocation unit',
  'modules.resources.allocationCadence.label': 'Allocation cadence',
  'modules.resources.allocationCadence.help':
    'One-time, or a recurring rate (per week / per month).',
  'modules.resources.estimate.label': 'Estimate',
  'modules.resources.estimate.help': 'A rough planning size, not a booking.',
  'modules.resources.estimateUnit.label': 'Estimate unit',
  'modules.resources.budget.label': 'Budget',
  'modules.resources.budget.help': 'Money planned for this item, one-time or recurring.',
  'modules.resources.budgetCurrency.label': 'Currency',
  'modules.resources.budgetCadence.label': 'Budget cadence',
  'modules.checklist.label': 'Checklist',
  'modules.checklist.description': 'The lines of the list under the item, each with a box to tick.',
  'modules.schedule.label': 'Schedule',
  'modules.schedule.description':
    'When this runs: a start and end (a date or anchored to another item), and a duration.',
  'modules.schedule.startTime.label': 'Start',
  'modules.schedule.startTime.help':
    'When this starts (a date, or any precision: 2026-W24, 2026-Q3).',
  'modules.schedule.startAnchor.label': 'Start anchor',
  'modules.schedule.startAnchor.help': 'Start relative to another item, plus an offset.',
  'modules.schedule.startOffset.label': 'Start offset',
  'modules.schedule.startOffsetUnit.label': 'Start offset unit',
  'modules.schedule.endTime.label': 'End',
  'modules.schedule.endTime.help':
    'When this is needed by. Past the end and the item reads as late.',
  'modules.schedule.endAnchor.label': 'End anchor',
  'modules.schedule.endAnchor.help': 'End relative to another item, plus an offset.',
  'modules.schedule.endOffset.label': 'End offset',
  'modules.schedule.endOffsetUnit.label': 'End offset unit',
  'modules.schedule.duration.label': 'Duration',
  'modules.schedule.duration.help': 'How long this takes, in the chosen unit.',
  'modules.schedule.durationUnit.label': 'Duration unit',
  'modules.schedule.cadence.label': 'Cadence',
  'modules.schedule.cadence.help':
    'The expected beat: how often this is meant to move (e.g. every 1 week). Standing work stays healthy while quiet for about one beat.',
  'modules.schedule.cadenceUnit.label': 'Cadence unit',
} as const;
